/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useStaticQuery, graphql } from 'gatsby';
import React from 'react';

export default function SEO({
  title,
  description,
  image,
  pathname,
  article = false,
}: {
  title?: string | null;
  description?: string;
  image?: string;
  pathname?: string;
  article?: boolean;
}) {
  const { site } = useStaticQuery(graphql`
    query SEO {
      site {
        siteMetadata {
          defaultTitle: title
          titleTemplate
          defaultDescription: description
          siteUrl: url
          defaultImage: image
        }
      }
    }
  `);

  const {
    defaultTitle,
    titleTemplate,
    defaultDescription,
    siteUrl,
    defaultImage,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  } = site.siteMetadata;

  const seo = {
    title: title ?? defaultTitle,
    description: description ?? defaultDescription,
    image: `${siteUrl}${image ?? defaultImage}`,
    url: `${siteUrl}${pathname ?? '/'}`,
  };

  return (
    <>
      <title>{titleTemplate.replace('%s', seo.title)}</title>
      <meta content={seo.description} name="description" />
      <meta content={seo.image} name="image" />
      {seo.url ? <meta content={seo.url} property="og:url" /> : null}
      {(article ? true : null) ? (
        <meta content="article" property="og:type" />
      ) : null}
      {seo.title ? <meta content={seo.title} property="og:title" /> : null}
      {seo.description ? (
        <meta content={seo.description} property="og:description" />
      ) : null}
      {seo.image ? <meta content={seo.image} property="og:image" /> : null}
      <meta content="summary_large_image" name="twitter:card" />
      {seo.title ? <meta content={seo.title} name="twitter:title" /> : null}
      {seo.description ? (
        <meta content={seo.description} name="twitter:description" />
      ) : null}
      {seo.image ? <meta content={seo.image} name="twitter:image" /> : null}
    </>
  );
}
